import { render, staticRenderFns } from "./QuestionReadingSelect.vue?vue&type=template&id=1d4642c7"
import script from "./QuestionReadingSelect.vue?vue&type=script&lang=js"
export * from "./QuestionReadingSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports